
import { useState } from "react";
import { Card } from "@material-ui/core";
import { Button, DialogActions} from "@mui/material";
// import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import api from "../../services/api";
import FazerObservacoes from "../components/fazerObservacoes.";
import LoadingShort from "../../load/loadingShort";


export default function CreateObservacaoExpediente({ expedienteId, userId, observacoes, setUpdate }) {
    const [messageError, setMessageError] = useState('')
    const [observacao, setObservacao] = useState('')
    const [load, setLoad] = useState(false)

    const sendObservacao = async () => {
        setUpdate(false)
        setLoad(true)
        setMessageError('')

        await api.patch('/expediente/add-observacao', { expedienteId, userId, 'content': observacao })
            .then(response => {
                setLoad(false)
                setUpdate(true)
                clearInput()

            }).catch(error => {
                // console.log(error)
                setLoad(false)
                setMessageError(error.response.data.message)
            })
    }

    const clearInput = () => {
        document.getElementById('inputObs').value = '';
        setObservacao('')
    }

    return (
        <Card style={{ padding: 20, position: 'relative', marginTop: 10 }}>
            {messageError && <MessageError message={messageError} />}

            {/* {observacoes?.length > 0 &&
                <>
                    <Typography variant="subtitle1" >
                        Observações feitas:
                    </Typography>

                    {observacoes.map(observacao =>
                        <div key={observacao._id}>
                            <br />
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Avatar src={observacao?.admin?.dadosPessoais.fotoURL} style={{ marginRight: 5 }} />
                                <Typography lineHeight={1} noWrap variant="body1">
                                    <ShortNome nome={observacao?.admin?.dadosPessoais?.nome} />
                                    <br />
                                    <small><DateHora date={observacao?.data} /></small>
                                </Typography>
                            </div>
                            <TextoFormatado texto={observacao.content} />
                            <Divider />
                        </div>
                    )}
                </>
            } */}

            <br />
            <FazerObservacoes
                observacao={observacao}
                setObs={setObservacao}
                // obs={obs}
                titulo="(Caso precise descreve aquí qualquer observação sobre este expediente.)"
            />

            <DialogActions>
                <Button disabled={!observacao || load} onClick={() => { sendObservacao() }} size="small" variant="contained" style={{ background: '#85287e' }}>
                    {load ? <LoadingShort /> : 'Enviar'}
                </Button>
            </DialogActions>
        </Card>
    )
}